<form autocomplete="off" #saisieForm="ngForm">
    <div class="row">
        <div class="col-md-6">
            <div class="row">
                <custom-input ngDefaultControl name="customVille"
                              customType="checkbox"
                              lCol="5" rCol="7"
                              [ngModel]="isCustomVille"
                              [(customModel)]="isCustomVille"
                              libelle="lieu.villeCustom.title"
                              postLibelle="lieu.villeCustom.label" [postTooltip]="'lieu.villeCustom.tooltip' | translate">
                </custom-input>
            </div>
            <div *ngIf="isCustomVille" class="row" [ngClass]="{ 'has-error': inputVille?.invalid }">
                <label class="col-md-5 required"><span [translate]="'lieu.ville'"></span></label>
                <div class="col-md-7">
                    <mat-form-field class="d-flex">
                        <input matInput #inputVille="ngModel" [(ngModel)]="localisation.ville" (ngModelChange)="setAdresseModifiee();" name="ville" maxlength="2000" autocomplete="off" required/>
                    </mat-form-field>
                </div>
            </div>
            <div class="row" [ngClass]="{ 'has-error': rue.invalid }">
                <label class="col-md-5"><span [translate]="'lieu.numeroEtVoie'"></span></label>
                <div class="col-md-7">
                    <mat-form-field class="d-flex">
                        <input matInput [(ngModel)]="localisation.rue" #rue="ngModel" (ngModelChange)="setAdresseModifiee()" name="rue" maxlength="2000" autocomplete="off"
                               [required]="lieuParam.isRueRequired"/>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="row" style="height:56px">
                <!-- Le choix  de la visibilité est possible dans le cas d'une saisie d'adresse pro/perso sur un profil user, par un admin ou sous-admin -->
                <custom-input [hidden]="!lieuParam.isShowProPersoAdresseFiltre || !typeAdresse"
                              customType="checkbox"
                              lCol="5" rCol="7"
                              [ngModel]="isAdressePublique"
                              [(customModel)]="isAdressePublique"
                              [disabled]="!localisation.rue" (click)="isVisibiliteDefinie=true"
                              libelle="lieu.visibilite.title"
                              name="adressePublique"
                              ngDefaultControl
                              postLibelle="lieu.visibilite.label" [postTooltip]="'lieu.visibilite.tooltip' | translate">
                </custom-input>
            </div>
            <div class="row" *ngIf="isCustomVille" [ngClass]="{ 'has-error': codePostal.invalid }">
                <label class="col-md-5"><span [translate]="'lieu.codePostal'"></span></label>
                <div class="col-md-7">
                    <mat-form-field class="d-flex">
                        <input matInput [(ngModel)]="localisation.codePostal" #codePostal="ngModel"
                               (ngModelChange)="setAdresseModifiee();" name="codePostal" maxlength="2000" autocomplete="off"/>
                    </mat-form-field>
                </div>
            </div>
            <div *ngIf="!isCustomVille" class="row" [ngClass]="{ 'has-error': autocompleteVille?.invalid }">
                <label class="col-md-5 required"><span [translate]="'lieu.ville'"></span></label>
                <div class="col-md-7">
                    <autocomplete type="geographie" ngDefaultControl #autocompleteVille="ngModel" name="saisieVille" required="true"
                                  [filter]="{ listeTypes: ['VILLE'] }" [(ngModel)]="saisieVille" floatLabel="never"
                                  (onSelect)="onVilleChange($event);"></autocomplete>
                </div>
            </div>
            <div class="row" [hidden]="!isCustomVille" [ngClass]="{ 'has-error': autocompletePays.invalid }">
                <label class="col-md-5 required"><span [translate]="'lieu.pays'"></span></label>
                <div class="col-md-7">
                    <autocomplete type="geographie" ngDefaultControl #autocompletePays="ngModel" name="saisiePays" required="true"
                                  [filter]="{ listeTypes: ['PAYS'] }" [(ngModel)]="saisiePays" floatLabel="never"
                                  (onSelect)="onPaysChange($event);"></autocomplete>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 text-end">
            <button *ngIf="lieuParam.isBoutonValider" mat-stroked-button color="primary"
                    (click)="onValider()"
                    [disabled]="isLoading || isValiderDisabled()"
                    style="margin-right: 10px">
                <span *ngIf="!isLoading" translate>global.actions.valider</span>
                <mat-spinner class="m-5" diameter="28" *ngIf="isLoading"></mat-spinner>
            </button>
            <button *ngIf="isGeoloc()" mat-flat-button color="primary"
                    (click)="validerSaisie()"
                    [disabled]="isLoading || isGeolocaliserDisabled()">
                <span *ngIf="!isLoading" translate>lieu.geolocButton</span>
                <mat-spinner class="m-5" diameter="28" *ngIf="isLoading"></mat-spinner>
            </button>
        </div>
    </div>
</form>
